<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
  >
    <g
      id="초기화_버튼"
      data-name="초기화 버튼"
      transform="translate(-925 -771)"
    >
      <g
        id="초기화_btn"
        transform="translate(925 771)"
        fill="none"
        stroke="#3e10a5"
        stroke-width="4"
      >
        <rect width="80" height="80" rx="10" stroke="none" />
        <rect x="2" y="2" width="76" height="76" rx="8" fill="none" />
      </g>
      <path
        id="초기화_아이콘"
        data-name="초기화 아이콘"
        d="M20,18h8V16A12,12,0,1,0,16,28h2v4H16A16,16,0,1,1,32,16v2h8L30,28Z"
        transform="translate(949 829.509) rotate(-90)"
        fill="#3e10a5"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ResetIcon'
}
</script>

<style></style>
